import type { IconProps } from "./icon-types";

/**
 * 되돌리기(restore). 기본값 복원/초기 상태로 되돌리기 진입점에서 사용.
 *
 * Tabler Icons의 `TbRestore` path를 인라인으로 그대로 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * Tabler 원본이 24 그리드 / stroke(2) 기반이라 다른 c6 stroke 글리프(RotateCcw 등)와
 * 선굵기·round cap이 그대로 통일된다.
 */
export const RestoreIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M3.06 13a9 9 0 1 0 .49 -4.087" />
    <path d="M3 4.001v5h5" />
    <path d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  </svg>
);
